import { Loader2 } from 'lucide-react';

export default function EditRoleLoadingBanner() {
  return (
    <div className="px-[22px] py-10 flex items-center justify-center gap-2 text-[13px] text-stone-500 dark:text-stone-400">
      <Loader2 size={16} className="animate-spin" />
      Loading current roles…
    </div>
  );
}
